





















import {
  Vue,
  Component,
} from "@/shared/vuepack";
import { useUserStore } from "@/shared/store/user";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";

@Component({
  components: {}
})
export default class WexRedirect extends Vue {
  userStore = useUserStore();
  hsabAccountsStore = useHsabAccountsStore();

  deeplinkUrl = null;

  onGoToWexClick () {
    this.hsabAccountsStore.navigateToWex();
  }

  onLogOutClicked () {
    this.userStore.logout();
  }

}
